import React from 'react';

import ShadeSVG from './assets/shade-on.svg';

export const ShadeOn = () => (
  <div data-testid="shade-on">
    <img src={ShadeSVG} alt="" />
  </div>
);
